export default __webpack_public_path__ + "static/media/44.4bf9184b.png";